// src/components/obs/VerticalStage.jsx
// Palco 9:16 (540x960 logici) scalato per riempire la Browser Source mantenendo
// le proporzioni. I figli stanno dentro la fascia libera (di norma quella bassa,
// sopra i commenti della diretta).
import React, { useEffect, useState } from 'react';
import { V_W, V_H } from '../../utils/obsFormat';
import './VerticalStage.css';

const fitScale = () => {
  if (typeof window === 'undefined') return 1;
  return Math.max(0.1, Math.min(window.innerWidth / V_W, window.innerHeight / V_H));
};

export default function VerticalStage({ box, className = '', children }) {
  const [scale, setScale] = useState(fitScale);
  useEffect(() => {
    const onResize = () => setScale(fitScale());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return (
    <div
      className={`ov-stage ${className}`}
      style={{
        width: V_W,
        height: V_H,
        transform: `translate(-50%, -50%) scale(${scale})`,
        '--ov-safe-top': `${box?.top ?? 460}px`,
        '--ov-safe-bottom': `${box?.bottom ?? 240}px`,
      }}
    >
      {children}
    </div>
  );
}
